import { TextLink } from '@neo4j-ndl/react';

type GqlStatusDocumentationLinkProps = {
  gqlStatus: string | undefined;
  documentationUrl: string | undefined;
};

export function GqlStatusDocumentationLink({ gqlStatus, documentationUrl }: GqlStatusDocumentationLinkProps) {
  if (gqlStatus === undefined || documentationUrl === undefined) {
    return null;
  }

  return (
    <TextLink as="a" className="text-sm" href={documentationUrl} type="external">
      Read documentation for {gqlStatus}
    </TextLink>
  );
}
